import axios from 'axios';

const MEIS_EDU_TOKEN = 'MEIS_EDU_TOKEN';

let navigateFn = null;

export function setNavigate(fn) {
  navigateFn = fn;
}

// Request interceptor — attach token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(MEIS_EDU_TOKEN);
    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
  },
  (err) => Promise.reject(err)
);

// Response interceptor — redirect on 401
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (navigateFn) navigateFn('/login');
    }
    return Promise.reject(error);
  }
);

export { MEIS_EDU_TOKEN };
export default axios;
